import { Component } from '@angular/core';

import { HomePage } from '../home/home';
import { WorkordersPage } from "../workorders/workorders";
import { SearchUnitPage } from "../search-unit/search-unit";
import { NotificationsPage } from "../notifications/notifications";
import { CompanyFilesPage } from "../company-files/company-files";
import { AlertController, ModalController, NavController } from "ionic-angular";
import { ReportService } from "../../services/report.service";
import { DataService } from "../../services/data.service";
import { FlashlightService } from "../../services/flashlight.service";
import { NewsModalPage } from "../news-modal/news-modal";
import {TranslateService} from "@ngx-translate/core";

@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage {

  tab1Root = HomePage;
  tab2Root = WorkordersPage;
  tab3Root = SearchUnitPage;
  tab4Root = CompanyFilesPage;
  tab5Root = NotificationsPage;

  workordersTabIndex = 1;
  searchUnitTabIndex = 3;

  menuOpen = false;

  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public dataService: DataService,
    public alertCtrl: AlertController,
    public flashlight: FlashlightService,
    public translate: TranslateService,
    public reportService: ReportService
  ) {

  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
    if(!this.menuOpen) {
      this.flashlight.switchOff();
    }
  }

  closeMenu() {
    this.menuOpen = false;
    this.flashlight.switchOff();
  }

  getTabs() {
    let navs = this.navCtrl.getActiveChildNavs();
    return navs[0];
  }

  selectTab(index){
    let tabs = this.getTabs();
    return tabs.select(index);
  }

  goToNewWorkorder() {
    this.closeMenu();
    if(this.reportService.isActive()){
      this.alertCtrl.create({
        title: 'Fout',
        message: 'Je kunt geen nieuwe werkorder starten, omdat je nog bezig bent met een andere werkorder.',
        cssClass: 'alert-error',
        buttons: ['OK']
      }).present();
      return;
    }
    let tabs = this.getTabs();
    tabs.select(this.workordersTabIndex).then(() => {
      setTimeout(() => {
        let page = tabs.getSelected().getActive().instance;
        if(page instanceof WorkordersPage){
          /** @var page WorkordersPage **/
          page.chooseNewWorkorderType();
        }
      }, 500);
    });
  }

  goToWorkorders() {
    this.closeMenu();
    this.selectTab(this.workordersTabIndex);
  }

  goToSearchUnit() {
    this.closeMenu();
    this.selectTab(this.searchUnitTabIndex);
  }

  goToFeedback() {
    this.closeMenu();
    this.dataService.openFeedbackForm();
  }

  public goToNews(){
    var modal = this.modalCtrl.create(NewsModalPage, {}, {
      enableBackdropDismiss: false,
      cssClass: 'modal-fullscreen'
    });
    modal.present();
  }

  toggleFlashlight(){
    this.flashlight.toggle();
  }

  isFlashlightOn(){
    return this.flashlight.isSwitchedOn();
  }

}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts